import { useTranslation } from '../../../hooks/useNavConfig';
import { StyledAccountMenuItem, StyledOptInOptOutAccountMenuItemButton } from './OptInOptOutAccountMenuItem.styles';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { getOptinsStatusThunk, updateOptinsStatusThunk } from '../thunks/optins.thunk';
import { OPTIN_NAME } from '../constants/optins';
import { selectOptinsStatus, selectUpdateOptinsStatus } from '../selectors/optins.selectors';
import { RequestStatus } from '../../../interface';
import { LoadingSpinner } from '../../../nav-ui-components/LoadingSpinner';
import { invalidateNavConfigThunk } from '../thunks/invalidateNavConfig.thunk';
import getWindow from '../../../utils/getWindow';
import { selectInvalidateNavConfigStatus } from '../selectors/invalidateNavConfig.selectors';
import { useAsyncEffect } from 'react-utils/hooks/useAsyncEffect';
import { trackUsage } from '../../../deferred/analytics/NavUsageTrackers';
import { jsx as _jsx } from "react/jsx-runtime";
export const OptInOptOutAccountMenuItem = () => {
  var _optinsStatus$data;
  const {
    t
  } = useTranslation();
  const dispatch = useAppDispatch();
  const updateOptinsStatus = useAppSelector(selectUpdateOptinsStatus);
  const optinsStatus = useAppSelector(selectOptinsStatus);
  const invalidateNavConfigStatus = useAppSelector(selectInvalidateNavConfigStatus);
  useAsyncEffect(async () => {
    await dispatch(getOptinsStatusThunk(OPTIN_NAME));
  }, [dispatch]);
  const handleOptInClick = async () => {
    const updateResult = await dispatch(updateOptinsStatusThunk({
      optinName: OPTIN_NAME,
      status: 'OPTED_IN'
    }));
    if (updateOptinsStatusThunk.rejected.match(updateResult)) {
      return;
    }
    const invalidateResult = await dispatch(invalidateNavConfigThunk());
    if (invalidateNavConfigThunk.rejected.match(invalidateResult)) {
      return;
    }
    trackUsage('navOptinsEvent', {
      type: 'opt-in',
      location: 'account-menu'
    });
    getWindow().location.reload();
  };
  const handleOptOutClick = async () => {
    const updateResult = await dispatch(updateOptinsStatusThunk({
      optinName: OPTIN_NAME,
      status: 'OPTED_OUT'
    }));
    if (updateOptinsStatusThunk.rejected.match(updateResult)) {
      return;
    }
    const invalidateResult = await dispatch(invalidateNavConfigThunk());
    if (invalidateNavConfigThunk.rejected.match(invalidateResult)) {
      return;
    }
    trackUsage('navOptinsEvent', {
      type: 'opt-out',
      location: 'account-menu'
    });
    getWindow().location.reload();
  };
  if (updateOptinsStatus.status === RequestStatus.LOADING || optinsStatus.status === RequestStatus.LOADING || invalidateNavConfigStatus === RequestStatus.LOADING) {
    return /*#__PURE__*/_jsx(StyledAccountMenuItem, {
      children: /*#__PURE__*/_jsx(LoadingSpinner, {})
    });
  }
  if (updateOptinsStatus.status === RequestStatus.ERROR || optinsStatus.status === RequestStatus.ERROR || invalidateNavConfigStatus === RequestStatus.ERROR) {
    return /*#__PURE__*/_jsx(StyledAccountMenuItem, {
      children: t('nav.search.somethingWentWrong')
    });
  }
  if (((_optinsStatus$data = optinsStatus.data) === null || _optinsStatus$data === void 0 ? void 0 : _optinsStatus$data.state) === 'OPTED_OUT') {
    return /*#__PURE__*/_jsx(StyledOptInOptOutAccountMenuItemButton, {
      onClick: () => void handleOptInClick(),
      children: /*#__PURE__*/_jsx("span", {
        children: t('nav.accountMenu.optInLink')
      })
    });
  }
  return /*#__PURE__*/_jsx(StyledOptInOptOutAccountMenuItemButton, {
    onClick: () => void handleOptOutClick(),
    children: /*#__PURE__*/_jsx("span", {
      children: t('nav.accountMenu.optOutLink2')
    })
  });
};